import React from "react";

const FabButton = ({ onClick, title }) => (
    <button title={title || "Add More"} onClick={onClick} className="mdl-button mdl-js-button fab mdl-button--fab mdl-js-ripple-effect mdl-button--colored">
        <i className="material-icons text-white">add</i>
    </button>
);

export default FabButton;
